import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class FrontDeskInHouseReport extends AbstractReport {
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'number_of_nights',
    'number_of_guests',
    'rooms',
    'balance_due',
    'reservation_id',
    'guest_id',
)(FrontDeskInHouseReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/front-desk/in-house-report.model.js